import React from 'react';
import { Link } from 'react-router-dom';
import './consultation.css';

const Consultation = () => {
    const process = [
        {
            icon: 'mdi-phone-outline',
            title: '예약 문의',
            description: '전화 또는 문자로 문의주시면 빠르게 상담해드립니다.',
            href: 'tel:01090453707'
        },
        {
            icon: 'mdi-calendar-check-outline',
            title: '예약 가능 확인',
            description: '원하는 날짜와 사용 시간을 확인하여 예약 가능 여부를 안내해드립니다.'
        },
        {
            icon: 'mdi-credit-card-outline',
            title: '예약금 입금',
            description: '렌탈 금액의 30% 예약금 입금 후 예약이 확정됩니다.'
        },
        {
            icon: 'mdi-handshake-outline',
            title: '현장 설치 및 결제',
            description: '예약 일정에 맞춰 방문 설치 후 현장에서 잔금을 결제합니다.'
        }
    ];

    return (
        <div className="consultation-section">
            <div className="consultation-inner">
                <div className="consultation-left">
                    <p className="consultation-label">
                        무료 견적 상담
                    </p>

                    <h2>
                        최적의 솔루션을<br />
                        제안해 드리겠습니다.
                    </h2>

                    <p className="consultation-description">
                        공간과 목적에 맞는 장비를 제안하고<br />
                        상담부터 설치까지 전문적으로 도와드립니다.
                    </p>

                    <Link
                        to="/inquiry"
                        className="consultation-button"
                    >
                        견적문의 하기
                        <span>→</span>
                    </Link>
                </div>

                <div className="consultation-process">
                    {process.map((item, index) => {
                        const content = (
                            <>
                                <div className="process-icon">
                                    <i className={`mdi ${item.icon}`}></i>
                                </div>

                                <h3>{item.title}</h3>

                                <p>
                                    {item.description}
                                </p>
                            </>
                        );

                        return (
                            <React.Fragment key={item.title}>
                                {item.href ? (
                                    <a
                                        href={item.href}
                                        className="process-card process-card-link"
                                    >
                                        {content}
                                    </a>
                                ) : (
                                    <div className="process-card">
                                        {content}
                                    </div>
                                )}

                                {index !== process.length - 1 && (
                                    <span className="process-arrow">
                                        <i className="mdi mdi-chevron-right"></i>
                                    </span>
                                )}
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Consultation;